<template>
    <div class="game-responsive responsive_9x16">
        <iframe
            id="aviatrix-container"
            ref="container"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            allow="clipboard-write"
        >
        </iframe>
    </div>
</template>

<script>
import Vue from 'vue';
import utils from '../../../../../../_common/utils';

export default {
    name: 'game-aviatrix',
    computed: {
        lang: function() {
            return Vue.state.lang.currentLang;
        },
        session: function() {
            return Vue.state.aviatrix.session.get();
        },
        isLoggedIn: function() {
            return Vue.state.player.isLoggedIn();
        },
        container: function() {
            return this.$refs.container;
        }
    },
    mounted() {
        this.resetFrameAsync();
    },
    destroyed() {
        this.container && (this.container.innerHTML = '');
    },
    methods: {
        async resetFrameAsync() {
            if (!this.container) return;
            await Vue.state.player.ensure();
            if (this.isLoggedIn) {
                await Vue.state.aviatrix.session.open({ lang: this.lang });
            } else {
                await Vue.state.aviatrix.session.openDemo({ lang: this.lang });
            }
            this.container.src = this.session.url;
        },
        toggleFullScreen() {
            utils.openFullscreen(this.$refs.gameContent);
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/game/game-aviatrix.vue